import { diffWords } from 'diff';
import { Decoder } from './Decoder';

export const formatParagraphs = (entries) => {
    const paragraphs = [[]]

    for (const item of entries) {
        if (item.value.startsWith("\r\n")) {
            paragraphs.push([]);
        }

        const lastParagraph = paragraphs.pop();

        if (item.value.includes("\r\n")) {
            const lines = item.value.split("\r\n").filter(line => line !== '');
            const firstLine = lines.shift();

            if (firstLine) {
                lastParagraph.push({
                    value: firstLine,
                    added: item.added,
                    removed: item.removed
                });
            }

            paragraphs.push(lastParagraph);

            if (lines.length > 0) {
                for (const line of lines) {
                    paragraphs.push([{
                        value: line,
                        added: item.added,
                        removed: item.removed
                    }]);
                }
            }

            if (item.value.endsWith("\r\n")) {
                paragraphs.push([]);
            }
        } else {
            lastParagraph.push({
                value: item.value,
                added: item.added,
                removed: item.removed
            });
            paragraphs.push(lastParagraph);
        }
    }

    const paragraphsWithoutEmpty = paragraphs.filter(paragraph => paragraph.length > 0);
    return paragraphsWithoutEmpty
}

export const formatCorrection = (paragraphs) => {
    const result = paragraphs.map(paragraph => {
        const corrections = [];
        let skipNext = false;

        for (let i = 0; i < paragraph.length; i++) {
            if (skipNext) {
                skipNext = false;
                continue;
            }

            const slice = paragraph[i];
            const isCorrect = !slice.added && !slice.removed;
            const nextSlice = paragraph[i + 1];
            const value = slice.value.trim();

            if (nextSlice && !slice.added && slice.removed && nextSlice.added && !nextSlice.removed) {
                corrections.push({
                    userAnswer: value,
                    expected: nextSlice.value.trim(),
                    isCorrect
                });
                skipNext = true;
            } else {
                corrections.push({
                    userAnswer: slice.added ? "" : value,
                    expected: slice.removed ? "" : value,
                    isCorrect
                });
            }
        }

        return corrections;
    });

    return result
}

function entryToText(entry) {
    return entry.filter(p => p.trim() !== "").join("\r\n");
}

function decodeCorrection(correction, { userDecoder, expectedDecoder }) {
    return correction.map(paragraph => {
        return paragraph.map(slice => {

            return {
                ...slice,
                userAnswer: userDecoder.decode(slice.userAnswer),
                expected: expectedDecoder.decode(slice.expected),
            };
        });
    });
}

export const getCorrection = ({ textEntry, textExpected, keySensitive, ignoreJumpline }) => {

    const decoderEntry = new Decoder({ keySensitive });
    const decoderExpected = new Decoder({ keySensitive });

    if (ignoreJumpline) {
        const textEntryString = entryToText(textEntry.map(text => decoderEntry.encode(text)));
        const textExpectedString = entryToText(textExpected.map(text => decoderExpected.encode(text)));

        const result = diffWords(textEntryString, textExpectedString);
        const paragraphs = formatParagraphs(result);

        const correction = formatCorrection(paragraphs);
        return decodeCorrection(correction, { userDecoder: decoderEntry, expectedDecoder: decoderExpected });
    }

    const diff = Math.max(textEntry.length - textExpected.length, 0);
    const extraParagraphs = Array.from({ length: diff }).fill("");
    const allTextExpected = [...textExpected, ...extraParagraphs];

    const paragraphs = allTextExpected.map((expected, index) => {
        const entry = textEntry[index] ?? "";
        const entryEncoded = decoderEntry.encode(entry);
        const expectedEncoded = decoderExpected.encode(expected);

        return diffWords(entryEncoded, expectedEncoded);
    });

    const correction = formatCorrection(paragraphs);
    return decodeCorrection(correction, { userDecoder: decoderEntry, expectedDecoder: decoderExpected });
}

export const getNumCorrectWords = (corrections) => {
    if(!corrections) return 0;
    return corrections.flat().reduce((acc, currentCorrection) => {
        if (currentCorrection.isCorrect) {
            const words = currentCorrection.expected.split(" ");
            acc += words.length;
        }
        return acc
    }, 0);
}

export const getNumIncorrectWords = (corrections) => {
    if(!corrections) return 0;
    return corrections.flat().reduce((acc, currentCorrection) => {
        if (!currentCorrection.isCorrect) {
            const words = currentCorrection.expected.split(" ");
            acc += words.length;
        }
        return acc
    }, 0);
}   
